"use client";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Icon from "@/components/library/Icon";

export default function RequestCard({ onClick }: Readonly<{ onClick: () => void }>) {
  const { t } = useTranslation("partners");

  return (
    <button
      onClick={onClick}
      className={clsx(
        "group flex flex-col p-4 text-left rounded-xl transition-all duration-200",
        "bg-gray-50/50 dark:bg-gray-800/50",
        "shadow-sm hover:shadow-lg hover:-translate-y-0.5",
        "border border-dashed border-gray-200 dark:border-gray-700/50",
        "hover:bg-blue-50/30 dark:hover:bg-blue-950/20 cursor-pointer"
      )}
    >
      <div className="w-11 h-11 rounded-xl bg-white dark:bg-gray-700/30 border border-gray-100 dark:border-gray-600/30 flex items-center justify-center group-hover:border-gray-200 dark:group-hover:border-gray-600 transition-colors mb-3">
        <Icon icon="plus" className="text-gray-400 group-hover:text-gray-600 transition-colors" />
      </div>
      <h3 className="font-semibold text-gray-700 dark:text-gray-300 text-sm leading-snug">
        {t("marketplaceRequestFeature")}
      </h3>
      <p className="text-xs text-gray-500 mt-1 leading-relaxed">
        {t("marketplaceDontSeeWhatYouNeed")}
      </p>
    </button>
  );
}
